import React from 'react';
import { Link } from 'react-router-dom';
import { Headset, Zap, ShieldCheck } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="hidden md:block bg-white pt-6 pb-2 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Support Banner - Hidden per user request */}

        {/* Main Footer Content */}
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start mb-6 md:mb-12 gap-4 md:gap-10">

          {/* Logo and Tagline */}
          <div className="flex flex-col items-center md:items-start md:w-1/3">
            <Link to="/" className="flex-shrink-0 flex items-center mb-3">
              <img src="https://lokanatya.com/logo.png" alt="Lokanatya" className="h-10 object-contain filter drop-shadow-sm" />
            </Link>
            <p className="text-gray-500 text-sm text-center md:text-left leading-relaxed">
              Your premium destination for booking jatra shows instantly. Experience the culture with ease and comfort.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 md:gap-x-8 md:gap-y-4 text-sm font-medium text-gray-600 md:w-1/3">
            <Link to="/about" className="hover:text-red-600 transition-colors">About Us</Link>
            <Link to="/privacy-policy" className="hover:text-red-600 transition-colors">Privacy Policy</Link>
            <Link to="/terms-conditions" className="hover:text-red-600 transition-colors">Terms & Conditions</Link>
            <Link to="/delete-account" className="hover:text-red-600 transition-colors">Delete Account</Link>
            <Link to="/support" className="hover:text-red-600 transition-colors">Support</Link>
            <Link to="/faq" className="hover:text-red-600 transition-colors">FAQ</Link>
          </div>

          {/* App Download */}
          <div className="flex justify-center md:justify-end md:w-1/3">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
              alt="Get it on Google Play"
              className="h-12 cursor-pointer hover:opacity-90 hover:-translate-y-0.5 transition-all drop-shadow-sm"
            />
          </div>
        </div>

        {/* Copyright */}
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start text-xs text-gray-400 pt-2 border-t border-gray-100 gap-4">
          <div className="text-center md:text-left">
            <p className="mb-1 text-gray-900 font-medium">Copyright 2026 © Lokanatya. All Rights Reserved.</p>
          </div>
          <div className="text-center md:text-right md:max-w-md">
            <p>The content and images used on this site are copyright protected. Usage is intended to promote the works and no endorsement of the artist shall be implied.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
